<template>
  <div class="iframe-wrap" id="main-wrap">
    <iframe
      id="main"
      :src="iframeSrc"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'TtcIframe',
  props: {
  },
  data () {
    return {
      iframeSrc: ''
    }
  },
  mounted () {
    const token = localStorage.getItem('token')
    // this.iframeSrc = `${process.env.VUE_APP_TTC_URL}/businessKanban?isKanbanIframe=true&token=${token}`
    this.iframeSrc = `${process.env.VUE_APP_TTC_URL}/boardManage/realTimeKanban?isKanbanIframe=true&token=${token}`
  },
  watch: {

  },
  methods: {
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
.iframe-wrap{
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    #main{
        width: 100%;
        transform-origin: left top;
    }
}
</style>
